export default __webpack_public_path__ + "static/media/short_logo.35febf04.png";